module.exports = __webpack_public_path__ + "static/best-est-roi-small-business-2021-6698ceb56410ce06d216dd0dbac9f140.svg";